import { useEffect, useState, useRef, useCallback } from 'react';
import { Col, Card, CardBody, CardHeader, CardFooter, Table, Row } from 'reactstrap';
import dragula from 'react-dragula';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { H6, H5, Btn, Spinner } from 'AbstractElements';
import AttachModal from 'Component/Learning/Common/TryoutModal/AttachModal';
import { detachTryout, orderTryoutQuestion, fetchTryout } from 'Features/Learning/Tryout/Utils/TryoutUtils';
import { handleDetach } from 'Component/Learning/Tryout/TryoutUtils';
import { setIdDetach, setDetachments } from 'Features/Learning/Tryout/detachTryoutSlice';
import { setIdAttach } from 'Features/Learning/Tryout/attachTryoutSlice';
import { setDetail } from 'Features/Learning/Tryout/tryoutSlice';
import { setFilters } from 'Features/Learning/BankQuestions/QuestionSlice';
import RawComponent from 'Component/Learning/Common/RawHTML';
import ModalComponent from 'Component/Learning/Common/Modal/ModalGeneral';
import Moment from 'moment';
import Swal from 'sweetalert2';
import ModalExportRanking from './ModalExportRanking';
import ModalDetailTOEFL from './ModalDetailTOEFL';
import './TryoutDetail.css';
// Import helper getQuestionType yang dinamis (cek interactive_type dulu)
import { getQuestionType } from 'Utils/getQuestionType';

const BoxListTryoutDetail = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const detail = useSelector(state => state.Tryout.detail);
  const data = useSelector(state => state.detachTryout);
  const filterTryout = useSelector(state => state.Tryout.filters)
  const filtersQuestion = useSelector(state => state.Question.filters)
  const isLoading = useSelector(state => state.Tryout.isLoading)
  const [isSaveButtonVisible, setSaveButtonVisible] = useState(false);
  const [_, setRefatch] = useState(false)
  const [orderQuestion, setOrderQuestion] = useState([])
  const [modalToeflOpen, setModalToeflOpen] = useState(false);
  const addButtonRef = useRef(null);
  const prevDetailIdRef = useRef(null);
  const detailId = detail?.id;

  // Initial scroll saat first load atau id berubah (pindah tryout)
  useEffect(() => {
    if (detailId) {
      // Scroll ke atas hanya saat pertama kali atau id tryout berubah
      if (prevDetailIdRef.current !== detailId) {
        window.scrollTo(0, 0);
        prevDetailIdRef.current = detailId;
      }
    }
  }, [detailId]);

  // Side effects: dispatch handlers (dispatch saat detail id berubah)
  useEffect(() => {
    if (detailId) {
      dispatch(setIdDetach(detailId))
      dispatch(setIdAttach(detailId))
    }
  }, [detailId, dispatch]);

  // Callback untuk scroll ke tombol Tambah Soal setelah submit sukses
  const scrollToAddButton = useCallback(() => {
    if (addButtonRef.current) {
      addButtonRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, []);

  const dragulaDecorator = (componentBackingInstance) => {
    // console.log(componentBackingInstance, 'componentBackingInstance')
    if (componentBackingInstance) {
      let options = {
        moves: function (el, container, handle) {
          return handle.classList.contains('handle');
        }
      };
      dragula([componentBackingInstance], options).on('drop', function (el, target, source, sibling) {
        setSaveButtonVisible(true);
        // get array order id from elements
        const containerChildren = Array.from(target.children);
        //return new format array include id, order
        const order = containerChildren.map(child => child.id);
        setOrderQuestion(order)
      }
      );
    }
  };

  // helper untuk menentukan label tipe (mis. "Kuis Live", "Kuis TOEFL", "Tryout Live", dst.)
  const getTypeLabel = (item) => {
    // base: Kuis atau Tryout
    const base = item.is_quiz === 1 || item.is_quiz === '1' || item.is_quiz === true ? 'Kuis' : 'Tryout';
    // preferensi: jika live tampilkan Live, jika TOEFL tampilkan TOEFL.
    console.log(item.is_live)
    // jika keduanya ada, prioritaskan Live (ubah sesuai kebutuhan).
    if (item.is_live === 1 || item.is_live === '1' || item.is_live === true) return `${base} Live`;
    if (item.is_toefl === 1 || item.is_toefl === '1' || item.is_toefl === true) return `${base} TOEFL`;
    // fallback: jika tidak ada flag, biarkan base (Kuis atau Tryout)
    return base;
  };

  const handleSaveButtonClick = async () => {
    Swal.fire({
      title: 'Konfirmasi',
      text: 'Apakah Anda yakin ingin menyimpan urutan soal?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ya, Simpan',
      cancelButtonText: 'Batal',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const numberArray = orderQuestion.map(Number);
        const numberString = numberArray.toString();
        const dataOrder = {
          id: detail.id,
          question_id: numberString,
        }
        try {
          const setOrder = await dispatch(orderTryoutQuestion(dataOrder))
          if (setOrder.payload === true) {
            Swal.fire({
              icon: 'success',
              title: 'Sukses',
              text: 'Urutan soal berhasil disimpan',
            });
            setSaveButtonVisible(false);
            try {
              const newFilter = {
                ...filterTryout,
                'filter[id]': detail.id,
                'include[1]': 'questions',
                'page': 1,
              };
              const getTryout = await dispatch(fetchTryout(newFilter));
              if (getTryout.payload.success === true) {
                dispatch(setDetail(getTryout.payload.data[0]));
              }
            } catch (error) {
              console.log('Error getTryout after setOrder:', error);
            }
          }

        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Gagal',
            text: 'Urutan soal gagal disimpan',
          });
        }
      }
    });
  };

  return (
    <>
      {isLoading ? (
        <Col lg="12">
          <div className="loader-box">
            <Spinner attrSpinner={{ className: 'loader-30' }} />
          </div>
          <H6 attrH6={{ className: 'sub-title mb-0 text-center' }}>{'Data Loading...'}</H6>
        </Col>
      ) : (
        <Row>
          <Col sm="12" xl="12" lg="12" className="xl-100 box-col-12 order-1">
            <Card className="social-widget-card">
              <CardBody>
                <Col>
                  <Row>
                    <Col>
                      <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{detail.title || 'Title Tryout'}</H5>
                    </Col>
                    <Col className='text-end'>
                      <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>Tipe {getTypeLabel(detail)}</H5>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Deskripsi Tryout'}</H6>
                  <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}><RawComponent htmlContent={detail.description || 'Description Tryout'} /></H5>
                </Col>
                <Col className="mt-2">
                  {detail.is_toefl === 1 && Array.isArray(detail.toefl_setup) && detail.toefl_setup.length > 0 && (
                    <>
                      <Btn
                        attrBtn={{
                          color: 'info',
                          className: 'btn btn-info',
                          onClick: () => setModalToeflOpen(true)
                        }}
                      >
                        <i className="fa fa-table me-2"></i> Lihat TOEFL Setup
                      </Btn>
                      <ModalDetailTOEFL modalToeflOpen={modalToeflOpen} setModalToeflOpen={setModalToeflOpen} detail={detail} />
                    </>
                  )}
                </Col>
                <Row>
                  <Col>
                    <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Kategori Tryout'}</H6>
                    <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{(detail.category && detail.category.title) || 'Category Tryout'}</H5>
                  </Col>

                  <Col>
                    <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Kuota Tryout'}</H6>
                    <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{detail.quotas || 'Quotas Tryout'} Orang</H5>
                  </Col>

                  <Col>
                    <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Durasi Tryout'}</H6>
                    <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{detail.time || 'Time Tryout'} Menit</H5>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Tgl Mulai'}</H6>
                    <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{Moment(detail.start_at).format('ddd, D MMMM YYYY')}</H5>
                    <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{Moment(detail.start_at).format('HH:mm:ss')} WIB</H5>
                  </Col>

                  <Col>
                    <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Tgl Berakhir'}</H6>
                    <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{Moment(detail.end_at).format('ddd, D MMMM YYYY')}</H5>
                    <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{Moment(detail.end_at).format('HH:mm:ss')} WIB</H5>
                  </Col>
                </Row>
                {/* Lock Tryout Feature */}
                {detail.locked_type && detail.locked_type !== 'none' && (
                  <Row>
                    <Col>
                      <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Tipe Kunci'}</H6>
                      <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>
                        {detail.locked_type === 'analytics' && 'Analytics'}
                        {detail.locked_type === 'ranking' && 'Ranking'}
                        {detail.locked_type === 'both' && 'Keduanya (Analytics + Ranking)'}
                      </H5>
                    </Col>

                    <Col>
                      <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Terkunci Hingga'}</H6>
                      <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{Moment(detail.locked_until_at).format('ddd, D MMMM YYYY')}</H5>
                      <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>{Moment(detail.locked_until_at).format('HH:mm:ss')} WIB</H5>
                    </Col>
                  </Row>
                )}
                {(detail.locked_message && detail.locked_message !== '' && detail.locked_message !== null && detail.locked_message !== "<p></p>" && detail.locked_message !== "<p><br></p>") && (
                  <Row>
                    <Col>
                      <H6 attrH6={{ className: 'font-roboto mt-4' }}>{'Pesan Kunci'}</H6>
                      <H5 attrH5={{ className: 'counter mb-0 font-roboto font-primary mt-2' }}>
                        <RawComponent htmlContent={detail.locked_message} />
                      </H5>
                    </Col>
                  </Row>
                )}
                <Row>
                  {/* {detail.instruction && (
                      <Col>
                        <H6 attrH6={{ className: 'font-roboto mt-4 mb-2' }}>{'Instruksi'}</H6>
                        <ModalComponent title="Instruksi" type="html" content={detail.instruction} buttonLabel="Lihat Instruksi" size="lg"/>
                      </Col>
                      )} */}
                  {detail.ads_video && (
                    <Col>
                      <H6 attrH6={{ className: 'font-roboto mt-4 mb-2' }}>{'Video Iklan'}</H6>
                      <ModalComponent title="Video Iklan" type="video" content={detail.ads_video} buttonLabel="Lihat Video Iklan" size="lg" />
                    </Col>
                  )}
                  {detail.tutorial_video && (
                    <Col>
                      <H6 attrH6={{ className: 'font-roboto mt-4 mb-2' }}>{'Video Tutorial'}</H6>
                      <ModalComponent title="Video Tutorial" type="video" content={detail.tutorial_video} buttonLabel="Lihat Video Tutorial" size="lg" />
                    </Col>
                  )}
                </Row>
              </CardBody>
              <CardFooter>
                <Row>
                  <Col>
                    <H6 attrH6={{ className: 'font-roboto' }}>Created at: {Moment(detail.created_at).format('dddd, D MMMM YYYY')} - {Moment(detail.created_at).format('HH:mm:ss')} WIB</H6>
                    <H6 attrH6={{ className: 'font-roboto' }}>Updated at: {Moment(detail.updated_at).format('dddd, D MMMM YYYY')} - {Moment(detail.updated_at).format('HH:mm:ss')} WIB</H6>
                  </Col>
                  <Col sm="7" className='tryout-footer-actions'>
                    <Link className='tryout-footer-link' to={`${process.env.PUBLIC_URL}/learning/tryout-list`}>
                      <Btn attrBtn={{ color: 'warning', className: 'tryout-footer-btn tryout-btn-back' }}>
                        <i className="fa fa-chevron-circle-left fa-lg me-2"></i>Back
                      </Btn>
                    </Link>
                    <div className='tryout-footer-export'>
                      <ModalExportRanking />
                    </div>
                    <div className='tryout-footer-add' ref={addButtonRef}>
                      <AttachModal item={detail} type={'attach'} onSuccess={scrollToAddButton} />
                    </div>
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
          {/* { detail.question && detail.question.length > 0 && ( */}
          <Col sm="12 order-2">
            <Card>
              <CardHeader>
                <H5>
                  {'List Soal Tryout'}
                  {detail.is_toefl === 1 && Array.isArray(detail.toefl_setup) && detail.toefl_setup.length > 0 && (
                    <span style={{ fontWeight: 'normal', fontSize: 16, marginLeft: 12 }}>
                      (
                      {(detail.question ? detail.question.length : 0)}
                      {' / '}
                      {detail.toefl_setup.reduce((acc, curr) => acc + (parseInt(curr.total_questions) || 0), 0)}
                      {' soal'}
                      )
                    </span>
                  )}
                </H5>
              </CardHeader>
              <div>
                <Table className="table-responsive">
                  <thead className="table-light">
                    <tr>
                      <th scope="col" width="8%" className="text-center">{'#'}</th>
                      <th scope="col">{'ID'}</th>
                      <th scope="col">{'Judul Soal'}</th>
                      <th scope="col" width="15%" className="text-center">{'Tipe Soal'}</th>
                      <th scope="col" className="text-center">{'Kategori Soal'}</th>
                      <th scope="col" className="text-center" colSpan={2}>{'Aksi'}</th>
                    </tr>
                  </thead>
                  <tbody ref={dragulaDecorator}>
                    {detail.question && detail.question.length > 0 ? (
                      detail.question && detail.question.map((item, index) =>
                        <tr key={`tryout-${index}`} id={item.id}>
                          <td className="text-center">{index + 1}</td>
                          <td>{item.id}</td>
                          <td>
                            {item.title === '' ? 'No Title' : item.title}
                            <Btn
                              title="Lihat soal"
                              attrBtn={{
                                color: 'link',
                                outline: true,
                                className: 'p-1 ms-2',
                                onClick: () => {
                                  dispatch(setFilters({
                                    ...filtersQuestion,
                                    'filter[title]': item.title
                                  }))
                                  history(`${process.env.PUBLIC_URL}/learning/soal-list`)
                                }
                              }}
                            >
                              <i className="fa fa-share-square-o mx-auto fa-lg" style={{ color: '#376673' }}></i>
                            </Btn>
                          </td>
                          {/* Ganti hardcode switch jadi pakai helper getQuestionType (dinamis: cek interactive_type dulu) */}
                          <td className="text-center">
                            {getQuestionType(item)}
                          </td>
                          <td className="text-center">{item.pivot.category.title.replace(/\d/g, '')}</td>
                          <td className="justify-content-end d-flex">
                            <AttachModal item={item} type={'question'} />
                            <AttachModal item={item} type={'update'} />
                            <Btn
                              title={'Hapus Soal'}
                              attrBtn={{
                                color: 'link',
                                outline: true,
                                className: 'p-1',
                                onFocus: () => {
                                  dispatch(setDetachments({ ...data.detachments, 'question_id': item.pivot['question_id'], 'category_id': item.pivot['category_id'], 'order': item.pivot['order'] }))
                                },
                                onClick: () => {
                                  handleDetach(detail, setDetail, item, data, dispatch, detachTryout, setRefatch)
                                }
                              }}
                            >
                              <i className="fa fa-trash-o mx-auto text-danger fa-lg"></i>
                            </Btn>
                          </td>
                          <td className="handle"><Btn attrBtn={{ color: 'link', outline: true, className: 'p-1', style: { pointerEvents: 'none' } }}><i className="fa fa-align-justify mx-auto"></i></Btn></td>
                        </tr>
                      )
                    ) : (
                      <tr>
                        <td colSpan={5} className='text-center'>{'Belum ada soal'}</td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={6} className='text-end'>
                        {isSaveButtonVisible && (
                          <Btn attrBtn={{ color: 'warning', onClick: handleSaveButtonClick }}><i className="fa fa-list-ol fa-lg me-2"></i>Simpan Urutan Soal</Btn>
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>
            </Card>
          </Col>
          {/* )} */}
        </Row>
      )}
    </>
  );
};
export default BoxListTryoutDetail;